import { render } from "./AccountInfo.vue?vue&type=template&id=997851ee&ts=true"
import script from "./AccountInfo.vue?vue&type=script&lang=ts"
export * from "./AccountInfo.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__